import script from "./digital-incorporation-form-expired.vue?vue&type=script&setup=true&lang=js"
export * from "./digital-incorporation-form-expired.vue?vue&type=script&setup=true&lang=js"

import "./digital-incorporation-form-expired.vue?vue&type=style&index=0&id=e0ab2e52&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0ab2e52"]])

export default __exports__